import React from 'react';
import icons from 'src/icons';

import { SuperEllipse } from '@alfalab/core-components/icon-view/super-ellipse';
import { PureCell } from '@alfalab/core-components/pure-cell';

export const PasswordInstruction = () => (
    <React.Fragment>
        <PureCell direction='horizontal' verticalPadding='default'>
            <PureCell.Graphics>
                <SuperEllipse size={48}>
                    <img src={icons.SpaceIcon} alt='icon' width={24} height={24} />
                </SuperEllipse>
            </PureCell.Graphics>
            <PureCell.Content>
                <PureCell.Main>
                    <PureCell.Text titleColor='primary' valueColor='secondary' view='component'>
                        Свяжитесь с Help Desk
                    </PureCell.Text>
                    <PureCell.Text
                        titleColor='secondary'
                        valueColor='secondary'
                        view='primary-small'
                    >
                        Скажите, что забыли пароль и назовите коллегу, которому можно отправить ваш
                        временный пароль
                    </PureCell.Text>
                </PureCell.Main>
            </PureCell.Content>
        </PureCell>

        <PureCell direction='horizontal' verticalPadding='default'>
            <PureCell.Graphics>
                <SuperEllipse size={48}>
                    <img src={icons.MailIcon} alt='icon' width={24} height={24} />
                </SuperEllipse>
            </PureCell.Graphics>
            <PureCell.Content>
                <PureCell.Main>
                    <PureCell.Text titleColor='primary' valueColor='secondary' view='component'>
                        Получите временный пароль
                    </PureCell.Text>
                    <PureCell.Text
                        titleColor='secondary'
                        valueColor='secondary'
                        view='primary-small'
                    >
                        Отправим на рабочую почту коллеги и руководителя
                    </PureCell.Text>
                </PureCell.Main>
            </PureCell.Content>
        </PureCell>

        <PureCell direction='horizontal' verticalPadding='default'>
            <PureCell.Graphics>
                <SuperEllipse size={48}>
                    <img src={icons.KeyIcon} alt='icon' width={24} height={24} />
                </SuperEllipse>
            </PureCell.Graphics>
            <PureCell.Content>
                <PureCell.Main>
                    <PureCell.Text titleColor='primary' valueColor='secondary' view='component'>
                        Войдите через мобильное приложение и смените пароль
                    </PureCell.Text>
                    <PureCell.Text
                        titleColor='secondary'
                        valueColor='secondary'
                        view='primary-small'
                    >
                        Он&nbsp;действует 4&nbsp;часа. Зайдите в&nbsp;
                        <strong>Настройки &rarr; Изменение пароля</strong>
                    </PureCell.Text>
                </PureCell.Main>
            </PureCell.Content>
        </PureCell>
    </React.Fragment>
);
